// src/components/marketing/PrivacyPage.js
import React from "react";

const PrivacyPage = () => {
  return (
    <div className="container" style={{ maxWidth: 900, padding: "48px 16px" }}>
      <header style={{ textAlign: "center", marginBottom: 64 }}>
        <h1 style={{ marginBottom: 16, fontSize: "36px" }}>Privacy Policy</h1>
        <p style={{ color: "var(--muted, #64748b)", fontSize: "16px" }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </header>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>
          1. Information We Collect
        </h2>
        <p>
          We collect information you provide directly, such as your account
          details, project content, and communications with us. We also gather
          basic analytics data (e.g., page views, device type) to improve our
          services.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>
          2. How We Use Your Information
        </h2>
        <p>
          We use your information to operate, maintain, and improve the
          Inertia7 platform; to communicate with you; and to protect against
          fraudulent or malicious activity.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>
          3. How We Share Information
        </h2>
        <p>
          We do not sell your personal data. We may share your information with
          trusted service providers who assist in operating the platform, under
          agreements that require them to protect your data.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>4. Data Retention</h2>
        <p>
          We retain your information as long as your account is active or as
          needed to provide the service. You may request deletion of your data
          at any time by contacting us.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>5. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your personal
          information. Depending on your location, you may also have additional
          privacy rights under applicable laws.
        </p>
      </section>

      <section>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>6. Contact</h2>
        <p>
          For privacy-related questions or requests, contact us at{" "}
          <a href="mailto:privacy@inertia7.com">privacy@inertia7.com</a>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPage;
